'use client'
import Image from "next/image";
import React from "react";
import { useTranslations } from "next-intl";
import Link from "next/link";

export const StartUpCard = ({ post }) => {
  const t = useTranslations();
  return (
    <>
      <article
        key={post.id}
        className="overflow-hidden rounded-2xl transition-all duration-300 border lg:py-6 py-4 lg:px-6 px-4 bg-mainBgPurple"
      >
        <div className="aspect-[3/2] w-full rounded-2xl overflow-hidden relative">
          <Link href={`/startups/${post.slug}`}>
            <Image
              src={post.image}
              alt=""
              fill
              style={{ objectFit: "cover" }}
              className="h-full hover:scale-110 transition-all duration-300 rounded-lg"
            />
          </Link>
        </div>

        <div className="px-2 flex flex-col justify-between sm:min-h-[172px] min-h-[130px]">
          <div>
            <h3 className="sm:mt-6 mt-3 text-lg font-semibold leading-8 truncate tracking-tight text-mainDarkPurple">
              <Link
                href={`startups/${post.slug}`}
                className="mt-6 sm:text-2xl text-lg ont-semibold leading-8 tracking-tight text-mainDarkPurple"
              >
                {post.name}
              </Link>
            </h3>
            <p className="sm:text-base text-xs leading-7 mt-2 line-clamp-2  text-mainTextPurple">
              {post.sub_title}
            </p>
          </div>
          <Link href={`startups/${post.slug}`}>
            <button
              type="button"
              className="py-2 px-4 mt-4 text-white bg-mainLightPurple hover:bg-mainLightPurpleHover active:bg-mainLightPurpleActive text-center rounded-[60px] btnLspace font-semibold opacity-100 text-sm md:text-base"
            >
              {t("more")}
            </button>
          </Link>
        </div>
      </article>
    </>
  );
};

